import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisSkeletonDossierNavigationItems extends Vue {
    @Prop({ default: 5 }) readonly numberBoxes!: number
}
